import React from 'react';
import { Remote } from '@okapi/remote';
import { ssrRemote } from './styles';
import { PageContentConnected } from './pdp-page-content-connected';

export type PdpContentProps = {
  remoteTimeout: number;
};

export const PdpContent: React.FC<PdpContentProps> = ({ remoteTimeout }) => {
  return (
    <>
      <PageContentConnected data-qa="page-content" />
      {/* Нам нужно сделать рендер ремоута на SSR, иначе на клиенте он не отрендерится */}
      <div className={ssrRemote} data-qa="pdp-calculator">
        <Remote widget="calculator/root" id="pdp-calculator" serverTimeout={remoteTimeout} />
      </div>
    </>
  );
};
